import { useState, useMemo } from 'react';
import { useDynamicPricing } from '../api/useDynamicPricing';
import { FALLBACK_PRICES } from '../../config/tierPricing';

export interface PaymentPlan {
  id: string;
  nameId: string;
  price: number;
  popular?: boolean;
  badge?: string;
  featuresId: string[];
  discount?: {
    discountedPrice: number;
  };
}

export function useUpgradeModal() {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<PaymentPlan | null>(null);
  const { tiers } = useDynamicPricing();

  const proTier = tiers.find(t => t.id === 'professional');
  const proPrice = proTier?.finalPrice ?? proTier?.basePrice ?? FALLBACK_PRICES.PROFESSIONAL;

  // Build features from backend tier data, fallback to hardcoded
  const proFeatures: string[] = useMemo(() => {
    if (proTier?.features && proTier.features.length > 0) {
      return proTier.features
        .filter((f: { included?: boolean }) => f.included !== false)
        .map((f: { nameIndonesian?: string; name?: string }) => f.nameIndonesian ?? f.name ?? '');
    }
    return [
      'Unlimited sinyal AI (15-20/hari)',
      'Penjelasan AI detail dalam Bahasa Indonesia',
      'Notifikasi push real-time ke HP',
      'Semua 90+ saham Indonesia (BBCA, BBRI, BMRI, TLKM, ASII, dll)',
      'Dashboard analisis performa lengkap',
      'Tracking akurasi & statistik sinyal',
      'Tools manajemen risiko otomatis',
      'Support WhatsApp prioritas',
      'Akses VIP komunitas investor Indonesia'
    ];
  }, [proTier]);

  const professionalPlan: PaymentPlan = useMemo(() => ({
    id: 'professional',
    nameId: 'Profesional',
    price: proPrice,
    popular: proTier?.isPopular ?? true,
    badge: proTier?.badge || 'Paling Populer',
    featuresId: proFeatures
  }), [proPrice, proTier, proFeatures]);

  const openUpgradeModal = () => {
    setSelectedPlan(professionalPlan);
    setShowPaymentModal(true);
  };

  const closeUpgradeModal = () => {
    setShowPaymentModal(false);
    setSelectedPlan(null);
  };

  return {
    showPaymentModal,
    selectedPlan,
    openUpgradeModal,
    closeUpgradeModal
  };
}